export type TToastStatus = 'success' | 'warning' | 'error' | 'info'

export interface Toast {
  title: string;
  description: string;
  status: TToastStatus;
  id: number;
}

export type ToastPayload = { timeout?: number; title: string; description?: string }

function getRandomIntInclusive (min: number, max: number) {
  const minCeiled = Math.ceil(min)
  const maxFloored = Math.floor(max)
  return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled)
}

export const createToast = (status: TToastStatus, title: string, description?: string): Toast => ({
  title,
  description: description ?? '',
  status,
  id: getRandomIntInclusive(1000, 10000)
})

export const defaultTimeout = 3000
